"use client";

import { useCurrency } from "@/contexts/CurrencyContext";
import { useModal } from "@/contexts/ModalContext";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { usePathname } from "@/i18n/navigation";
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
} from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const { showLanguageAndCurrencyModal } = useCurrency();
  const pathname = usePathname();
  const reservationControlModal = useModal("reservation-control-modal");
  const t = useTranslationDetector();

  const showReservationControl = useCallback(() => {
    reservationControlModal.open({
      title: t("common.reservationcontrol"),
      isBottomSheet: true,
      size: "lg",
    });
  }, [reservationControlModal, t]);

  const value = useMemo(
    () => ({
      showLanguageAndCurrencyModal,
      showReservationControl,
    }),
    [showLanguageAndCurrencyModal, showReservationControl],
  );

  useEffect(() => {
    reservationControlModal.close();
  }, [pathname]);

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error("useHeaderContext must be used within HeaderProvider");
  }
  return context;
};
